function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "svg-2367830427-a",
  d: "M17.105 1.2c.526.325.97.769 1.295 1.295l10.153 16.4a4 4 0 0 1-3.401 6.107H4.847a4 4 0 0 1-3.401-6.106l10.152-16.4a4 4 0 0 1 5.507-1.297zm-3.697 2.189l-.11.159-10.152 16.4a2.001 2.001 0 0 0 1.508 3.044l.193.01h20.305a2 2 0 0 0 1.794-2.885l-.093-.169L16.7 3.548a1.989 1.989 0 0 0-.495-.543l-.153-.105a2 2 0 0 0-2.644.489zM15 17a1.667 1.667 0 1 1 0 3.334A1.667 1.667 0 0 1 15 17zm0-9.83c.506 0 .925.376.99.864l.01.136v5.944a1 1 0 0 1-1.99.135l-.01-.135V8.17a1 1 0 0 1 1-1z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  fill: "#C42B44",
  xlinkHref: "#svg-2367830427-a",
  fillRule: "evenodd"
});

var SvgWarningOutline = function SvgWarningOutline(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 26
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgWarningOutline;